'use client'
import { __awaiter } from '../../../../../../_virtual/_tslib.js';
import { useRef, useCallback, useEffect } from 'react';
import { StorageService } from '@dynamic-labs/utils';
import '@dynamic-labs/sdk-api-core';
import '../../../../config/ApiEndpoint.js';
import { DYNAMIC_AUTH_COOKIE_NAME } from '../../../../utils/constants/values.js';
import '@dynamic-labs/multi-wallet';
import { AUTH_TOKEN, AUTH_MIN_TOKEN, WALLET_PICKER_SEARCH_KEY, PHANTOM_SIGNATURE_STATE, AUTH_EXPIRES_AT } from '../../../../utils/constants/localStorage.js';
import '../../../../shared/logger.js';
import '../../../../utils/constants/colors.js';
import 'react-international-phone';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import '../../../ViewContext/ViewContext.js';
import '@dynamic-labs/wallet-book';
import '../../../../store/state/loadingAndLifecycle.js';
import '../../../../shared/consts/index.js';
import '../../../../store/state/projectSettings/projectSettings.js';
import { setUser } from '../../../../store/state/user/user.js';
import { revokeSession } from '../../../../data/api/session/session.js';
import '../../../../locale/locale.js';
import { dynamicEvents } from '../../../../events/dynamicEvents.js';

const useHandleLogout = (params) => {
    const paramsRef = useRef(params);
    paramsRef.current = params;
    const logout = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        const p = paramsRef.current;
        p.setSelectedWalletConnectorKey(null);
        p.clearAllWalletConnectSessions();
        p.setShowDynamicUserProfile(false);
        p.setShowBridgeWidget(false);
        p.resetLoginWithEmail();
        if (p.user) {
            // this deletes the auth cookie, if it exists
            // if the cookie doesn't exist, this sets a new cookie which would expire immediately
            document.cookie = `${DYNAMIC_AUTH_COOKIE_NAME}=; Max-Age=-99999999; path=/; SameSite=Lax`;
            // do not await this async call - just fire and forget
            revokeSession({
                environmentId: p.environmentId,
                sessionId: p.user.sessionId,
            });
        }
        p.setLegacyIsVerifying(false);
        // Clear storage
        StorageService.removeItem(AUTH_TOKEN, {
            priority: ['secureStorage', 'localStorage'],
        });
        StorageService.removeItem(AUTH_MIN_TOKEN, {
            priority: ['secureStorage', 'localStorage'],
        });
        StorageService.removeItem(WALLET_PICKER_SEARCH_KEY);
        StorageService.removeItem(PHANTOM_SIGNATURE_STATE);
        StorageService.removeItem(AUTH_EXPIRES_AT);
        p.setAuthMode(p.initialAuthenticationMode);
        p.setShowAuthFlow(false, {
            emitCancelAuth: false,
            ignoreIfIsEmbeddedWidget: false,
            initializeWalletConnect: false,
            performMultiWalletChecks: false,
        });
        p.setMultiWalletWidgetState('idle');
        p.removeConnectedWalletsInfo();
        p.removeBridgeOnboardingCompleted();
        p.clearPrimaryWalletId();
        p.removeConnectedNameService();
        p.removeSessionStorageSessionKeys();
        dynamicEvents.removeListener('embeddedWalletCreatePasswordCompleted');
        dynamicEvents.removeListener('embeddedWalletCreatePasswordFailed');
        dynamicEvents.removeListener('embeddedWalletUpdatePasswordCompleted');
        dynamicEvents.removeListener('embeddedWalletUpdatePasswordFailed');
        dynamicEvents.emit('logout');
        setUser(undefined);
        yield Promise.all(p.walletConnectors.map((connector) => connector.endSession()));
        yield Promise.all(p.connectedWallets.map((connectedWallet) => connectedWallet.connector.endSession()));
    }), []);
    /** Trigger a logout when the SDK failed to load data from storage */
    useEffect(() => {
        StorageService.events.on('parseFailure', logout);
        return () => {
            StorageService.events.off('parseFailure', logout);
        };
    }, [logout]);
    return logout;
};

export { useHandleLogout };
